// import React from "react";

// const AboutFour = () => {
//   return (
//     <div className="about-four about-four--one section-space" id="about">
      
//       {/* Background */}
//       <div
//         className="about-four__bg"
//         style={{ backgroundImage: "url(/images/shapes/about-bg.jpg)" }}
//       ></div>

//       <div className="container">
//         <div className="row gutter-y-40 align-items-center">
          
//           {/* Left Side Images */}
//           <div className="col-lg-6">
//             <div
//               className="about-four__image wow fadeInLeft"
//               data-wow-duration="1500ms"
//               data-wow-delay="150ms"
//             >
//               <div className="about-four__image__item">
//                 <img
//                   src="/images/about/about-1-1.jpg"
//                   alt="about"
//                 />
//               </div>

//               <div className="about-four__image__small">
//                 <img
//                   src="images/about/about-s-1-1.jpg"
//                   alt="about small"
//                 />
//                 <div className="about-four__image__item-video">
//                   <a
//                     className="video-popup"
//                     href="https://www.youtube.com/watch?v=0MuL8fd3pb8"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     <i className="fas fa-play"></i>
//                     <i className="ripple"></i>
//                   </a>
//                 </div>
//               </div>

//               {/* Fun Fact */}
//               <div className="about-four__funfact">
//                 <div className="about-four__funfact__icon">
//                   <i className="icon-hand-wall"></i>
//                 </div>

//                 <div className="about-four__funfact__content">
//                   <h4 className="about-four__funfact__number count-box">
//                     <span
//                       className="count-text"
//                       data-stop="6561"
//                       data-speed="1500"
//                     >
//                       6561
//                     </span>
//                     <span>+</span>
//                   </h4>
//                   <p className="about-four__funfact__text">
//                     Satisfied Clients
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Side Content */}
//           <div className="col-lg-6">
//             <div className="about-four__right">
//               <div className="sec-title">
//                 <div
//                   className="sec-title__top wow fadeInUp"
//                   data-wow-duration="1500ms"
//                   data-wow-delay="150ms"
//                 >
//                   <div className="sec-title__shape"></div>
//                   <h6 className="sec-title__tagline">
//                     ABOUT OUR COMPANY
//                   </h6>
//                 </div>

//                 <h3
//                   className="sec-title__title wow fadeInUp"
//                   data-wow-duration="1500ms"
//                   data-wow-delay="200ms"
//                 >
//                   Services with a Wide Range of Cars
//                 </h3>
//               </div>

//               <p
//                 className="about-four__top__text wow fadeInUp"
//                 data-wow-duration="1500ms"
//                 data-wow-delay="150ms"
//               >
//                 Whether you're embarking on a cross-country adventure or
//                 exploring a new destination by car, finding the right car rental
//                 vehicle is essential for a stress-free journey.
//               </p>

//               <div
//                 className="about-four__bottom wow fadeInUp"
//                 data-wow-duration="1500ms"
//                 data-wow-delay="150ms"
//               >
//                 {/* Emergency Call */}
//                 <div className="emargency-call">
//                   <div className="emargency-call__image">
//                     <img
//                       src="/images/resources/emargency-call-1-1.jpg"
//                       alt="support"
//                     />
//                     <div className="emargency-call__icon">
//                       <i className="icon-telephone-call"></i>
//                     </div>
//                   </div>

//                   <div className="emargency-call__content">
//                     <h4 className="emargency-call__title">
//                       Emergency Call Us
//                     </h4>
//                     <a
//                       href="tel:+912569003452"
//                       className="emargency-call__number"
//                     >
//                       +91 2569 003 452
//                     </a>
//                   </div>
//                 </div>

//                 {/* Button */}
//                 <div className="about-four__btn-box">
//                   <a
//                     href="/about"
//                     className="about-four__btn cityride-btn cityride-btn--secondary"
//                   >
//                     <span className="cityride-btn__icon">
//                       <i className="icon-front-car"></i>
//                     </span>
//                     <span>About More</span>
//                   </a>
//                   <div className="about-four__btn__border"></div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Shape */}
//       <div className="about-four__element">
//         <img
//           src="/images/shapes/download-app-shape-2-1.png"
//           alt="shape"
//         />
//       </div>
//     </div>
//   );
// };

// export default AboutFour;


import React from "react";

const AboutFour = () => {
  return (
    <div className="about-four about-four--one section-space" id="about">
      
      {/* Background */}
      <div
        className="about-four__bg"
        style={{ backgroundImage: "url(/images/shapes/about-bg.jpg)" }}
      ></div>

      <div className="container">
        <div className="row gutter-y-40 align-items-center">
          
          {/* Left Side Images */}
          <div className="col-lg-6">
            <div
              className="about-four__image wow fadeInLeft"
              data-wow-duration="1500ms"
              data-wow-delay="150ms"
            >
              <div className="about-four__image__item">
                <img
                  src="/images/about.jpg"
                  alt="Lotus Cab Service"
                />
              </div>

        

              {/* Fun Fact */}
              <div className="about-four__funfact">
                <div className="about-four__funfact__icon">
                  <i className="icon-hand-wall"></i>
                </div>

                <div className="about-four__funfact__content">
                  <h4 className="about-four__funfact__number count-box">
                    <span
                      className="count-text"
                      data-stop="12500"
                      data-speed="1500"
                    >
                      12500
                    </span>
                    <span>+</span>
                  </h4>
                  <p className="about-four__funfact__text">
                    Happy Customers 
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side Content */}
          <div className="col-lg-6">
            <div className="about-four__right">
              <div className="sec-title">
                <div
                  className="sec-title__top wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="150ms"
                >
                  <div className="sec-title__shape"></div>
                  <h6 className="sec-title__tagline">
                    ABOUT LOTUS CAB
                  </h6>
                </div>

                <h3
                  className="sec-title__title wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="200ms"
                >
                  Safe, Reliable & Affordable Cab Services
                </h3>
              </div>

              <p
                className="about-four__top__text wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="150ms"
              >
                Lotus Cab provides comfortable and affordable taxi services for
                local rides, airport transfers, and outstation trips. Our
                professional drivers and well-maintained fleet ensure a smooth
                and safe journey every time you travel with us.
              </p>

              <div
                className="about-four__bottom wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="150ms"
              >
                {/* Emergency Call */}
                <div className="emargency-call">
                  <div className="emargency-call__image">
                    {/* <img
                      src="/images/resources/emergency-call.jpg"
                      alt="Lotus Cab Support"
                    /> */}
                    {/* <div className="emargency-call__icon">
                      <i className="icon-telephone-call"></i>
                    </div> */}
                  </div>

                  <div className="emargency-call__content">
                    <h4 className="emargency-call__title">
                      Book Your Ride Now
                    </h4>
                    <a
                      href="tel:+918767592195"
                      className="emargency-call__number"
                    >
                      +91 8767592195
                    </a>
                  </div>
                </div>

                {/* Button */}
                <div className="about-four__btn-box">
                  <a
                    href="/about-us"
                    className="about-four__btn cityride-btn cityride-btn--secondary"
                  >
                    <span className="cityride-btn__icon">
                      <i className="icon-front-car"></i>
                    </span>
                    <span> About More</span>
                  </a>
                  <div className="about-four__btn__border"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Shape */}
   
    </div>
  );
};

export default AboutFour;
